import { createSelector } from 'reselect';
import { getCompanySettings } from './getCompanySettings';
import { getIsApmERPJobFlow } from './getIsApmERPJobFlow';

export const getWaitingForWorkEnabled = createSelector(
  [getCompanySettings, getIsApmERPJobFlow],
  (companySettings, isApmERPJobFlow) => {
    if (isApmERPJobFlow) return true;
    return companySettings?.enableWaitingForWork ?? false;
  }
);
